import Route from "@mpa/toolbox/navigation/Route";

import { loggedInNavigator } from "../../navigation/routes";

export const createProjectRoute = loggedInNavigator.addRoute(
    new Route().setPath("/nouveau-projet"),
);
